import * as React from 'react';

import { EmptyField, TextField } from '../../../../../../components/Field/common';
import { useOfferContext } from '../../../../../../utils/offerContext';

export const HouseNameFieldContainer: React.VFC = () => {
  const { published, newbuildingHouse: house } = useOfferContext();
  const houseName = house && house.name;

  if (!houseName) {
    return <EmptyField published={published} />;
  }

  return <TextField published={published}>{houseName}</TextField>;
};
